import React from 'react';
import JitsiVideocalls from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const HelpButton = React.lazy(() => import('../../../components/HelpButton'));
const JitsiVideocallSettings = React.lazy(() =>
  import('./JitsiVideocallSettings')
);

const JitsiVideocallSettingsPage = () => (
  <JitsiVideocalls>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <>
          <div className="text-right">
            <HelpButton fileName="videocall-settings" />
          </div>
          <JitsiVideocallSettings />
        </>
      </React.Suspense>
    </ErrorBoundary>
  </JitsiVideocalls>
);

export default JitsiVideocallSettingsPage;
